import React from "react";
import { Box } from "@mui/material";

const ScaleWrapper = ({ children, scale = 1 }) => {
  return (
    <Box
      sx={{
        transform: `scale(${scale})`,
        transformOrigin: "top left", // Adjust origin as needed
        width: `${100 / scale}%`, // Adjust width for scaling
        height: `${100 / scale}%`, // Adjust height for scaling
      }}
    >
      {children}
    </Box>
  );
};

export default ScaleWrapper;
